import { render, staticRenderFns } from "./MercadoPagoForm.vue?vue&type=template&id=2603216a&scoped=true"
import script from "./MercadoPagoForm.vue?vue&type=script&lang=js"
export * from "./MercadoPagoForm.vue?vue&type=script&lang=js"
import style0 from "./MercadoPagoForm.vue?vue&type=style&index=0&id=2603216a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603216a",
  null
  
)

export default component.exports